module.exports = __webpack_public_path__ + "img/L型悬臂箱.0a7492df.jpg";